import DocumentFolder from "./DocumentFolder";
import BaseModel from "./BaseModel";
import Product from "./Product";
import Order from "./Order";
import Customer from "./Customer";

export default class Document extends BaseModel {

	static entity = 'documents';
	static route = 'documents';
	static plural = 'documents';
	static singular = 'document';

	static fields () {
		return {
			id: this.attr(null),
			document_folder_id: this.attr(null),
			document_folder: this.belongsTo(DocumentFolder, 'document_folder_id'),
			name: this.attr(null),
			ext: this.attr(null),
			mime_type: this.attr(null),
			size: this.attr(null),
			description: this.attr(null),
			ref: this.attr(null),
			cover_id: this.attr(null),
			cover: this.belongsTo(Document, 'cover_id'),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
		}
	}

	get getFileUrl() {
		return process.env.VUE_APP_SF_SERVICE_URL + '/api/v1/' + Document.route + '/' + this.id + '/file';
	}

	get getDownloadUrl() {
		return process.env.VUE_APP_SF_SERVICE_URL + '/api/v1/' + Document.route + '/' + this.id + '/download';
	}

	get isImage() {
		return this.mime_type.split('/').shift() === 'image';
	}

	get isVideo() {
		return this.mime_type.split('/').shift() === 'video';
	}

	get isPdf() {
		return this.mime_type === 'application/pdf';
	}

	get getLink() {
		return (this.isPdf ? this.getFileUrl : (!this.isPdf && !this.isVideo ? this.getDownloadUrl : null));
	}

	get getLinkTarget() {
		return '_blank';
	}

	static get getHowToFolderId() {
		return 25;
	}

	static configureApi() {
		let config = super.configureApi();
		config.headers = {'Content-Type': 'multipart/form-data'};
		config.actions.file = function(id, mime_type, cache, request_config) {
			request_config = request_config || {};
			request_config.dataTransformer = () => {
				return [];
			};
			//if(mime_type && (mime_type === 'application/pdf' || mime_type === 'image/jpeg')) {
			if(mime_type && (mime_type !== 'image/svg')) {
				request_config.responseType = 'arraybuffer';
			}
			let path = '/'+this.model.route+'/'+id+'/file';
			if(cache === false) {
				path += '?token=' + Date.now();
			}
			return this.get(path, request_config);
		};
		config.actions.fetchProductDocuments = function(product_id, ref) {
			console.log('/'+Product.route+'/'+product_id+'/documents' + (ref ? '?ref='+ref : null));
			return this.get('/'+Product.route+'/'+product_id+'/documents' + (ref ? '?ref='+ref : null), {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'product_documents');
				}
			});
		};
		config.actions.attachProductDocument = function(product_id, document_id, ref) {
			return this.post('/'+Product.route+'/'+product_id+'/documents/'+document_id + (ref ? '/'+ref : null), {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'product_document');
				}
			});
		};
		config.actions.detachProductDocument = function(product_id, document_id, ref) {
			return this.delete('/'+Product.route+'/'+product_id+'/documents/'+document_id + (ref ? '/'+ref : null), {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'product_document');
				}
			});
		};
		config.actions.fetchOrderDocuments = function(order_id) {
			return this.get('/'+Order.route+'/'+order_id+'/documents', {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'order_documents');
				}
			});
		};
		config.actions.attachOrderDocument = function(order_id, document_id) {
			return this.post('/'+Order.route+'/'+order_id+'/documents/'+document_id, {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'order_document');
				}
			});
		};
		config.actions.detachOrderDocument = function(order_id, document_id) {
			return this.delete('/'+Order.route+'/'+order_id+'/documents/'+document_id, {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'order_document');
				}
			});
		};
		config.actions.getSignature = function() {
			return this.get('/'+Customer.route+'/signature', {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'document');
				}
			});
		};
		config.actions.updateCover = function(document_id, cover_id) {
			return this.post('/'+Document.route+'/'+document_id+'/cover/'+cover_id, {
				dataTransformer: (response) => {
					return Document.transformDefault(response, 'document');
				}
			});
		};
		return config;
	}

	static apiConfig = this.configureApi();

}
